import polylabel from 'polylabel'
import * as Constants from '@/lib/constants'
import storage from '@/lib/storage'

const DEFAULT_ZOOM_LEVEL = 4

export default {
  data() {
    return {
      fieldGeoJsons: { type: 'FeatureCollection', features: [] },
      markers: [],
    }
  },
  computed: {
    currentMapCenterForGoogle() {
      const center = this.$store.getters.currentMapCenter
      return { lat: center[1], lng: center[0] }
    },
    vectorMapId() {
      return Constants.GOOGLE_MAP_VECTOR_MAP_ID
    },
  },
  methods: {
    getDefaultZoomLevel() {
      return DEFAULT_ZOOM_LEVEL
    },
    getDefaultMapCenter() {
      if (this.isLanguage('en')) {
        return { lng: -98, lat: 38 } // U.S.A
      } else if (this.isLanguage('pt')) {
        return { lng: -58, lat: -15 } // Brazil
      } else if (this.isLanguage('es')) {
        return { lng: -4, lat: 41 } // Spain
      } else if (this.isLanguage('de')) {
        return { lng: 10, lat: 51 } // Germany
      } else if (this.isLanguage('pl')) {
        return { lng: 19, lat: 52 } // Poland
      } else if (this.isLanguage('ru')) {
        return { lng: 97, lat: 62 } // Russia
      }
      return { lng: 138, lat: 38 } // Japan
    },
    isLanguage(lang) {
      return storage.getUserLangConsideringDefault() === lang
    },
    drawAllFieldsOnGoogleMap() {
      const fields = this.$store.getters.fields
      this.fieldGeoJsons.features = []
      this.markers = []
      // field
      for (let i = 0; i < fields.length; i++) {
        const field = fields[i]
        const geoJson = JSON.parse(field.geoJson)

        if (geoJson != null) {
          geoJson.features.forEach(feature => {
            feature.properties.pk = fields[i].pk
            feature.properties.type = Constants.GeoFeaturePropertiesType.FIELD

            const coords = feature.geometry.coordinates[0]

            const firstCoords = coords[0]
            const lastCoords = coords[coords.length - 1]

            const firstCoordsStr = firstCoords.join('-')
            const lastCoordsStr = lastCoords.join('-')

            if (firstCoordsStr !== lastCoordsStr) {
              console.error('Polygon NOT closed!', feature)
              feature.geometry.coordinates[0].push(firstCoords)
            }

            this.fieldGeoJsons.features.push(feature)
            const center = polylabel(feature.geometry.coordinates, 1.0)
            const marker = {
              label: fields[i].name,
              position: { lat: center[1], lng: center[0] },
              // icon非表示用
              icon: {
                path: 'M -8,-8 8,8 M 8,-8 -8,8',
                strokeColor: '#000000',
                strokeWeight: 0,
              },
            }
            this.markers.push(marker)
          })
        }
      }

      this.$store.dispatch('setFieldGeoJsons', this.fieldGeoJsons)
    },
  },
}
